// extracted by mini-css-extract-plugin
export default {"mobile":"bubbles-module--mobile--83121","desktop":"bubbles-module--desktop--700e5"};